//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 안전보건인력 - 안전보건관리책임자 (SAP_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

const Inputs1 = {
  chaebun: '',
  evaContent1: '사업장의 산재예방계획 수립에 관한 사항',
  evaContent2: '안전보건관리규정의 작성 및 변경에 관한 사항',
  evaContent3: '근로자에 대한 안전보건교육에 관한 사항',
  evaContent4: '작업환경의 점검 및 개선에 관한 사항',
  evaContent5: '근로자의 건강진단 등 건강관리에 관한 사항',
  evaContent6: '산업재해의 원인 및 조사 및 재발 방지대책 수립에 관한 사항',
  evaContent7: '산업재해에 관한 통계의 기록 및 유지관리에 관한 사항',
  evaContent8: '위험성평가의 실시에 관한 사항',
  evaContent9:
    '안전보건규칙에서 정하는 근로자의 위험 또는 건강장해의 방지에 관한 사항',
  evaluation1: '보통',
  evaluation2: '보통',
  evaluation3: '보통',
  evaluation4: '보통',
  evaluation5: '보통',
  evaluation6: '보통',
  evaluation7: '보통',
  evaluation8: '보통',
  evaluation9: '보통',
  evaStartDate: dayjs().format('YYYY-MM-DD'),
  evaEndDate: dayjs().format('YYYY-MM-DD'),
  gubun: '1',
  improvements: '',
  name: '',
  opinion: '',
};

// URL 인코딩 처리 함수
const fixUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const parts = url.split('/');
  const fileName = parts.pop();
  const encodedFileName = encodeURIComponent(fileName);
  return [...parts, encodedFileName].join('/');
};

// 사진 가져오기 함수 (journeyman 이미지)
const SearchPhoto = async (_path, imgRef) => {
  imgRef.current = null;
  try {
    await Commons.Axios(
      'post',
      Global.base.useUrl + Global.urls.Execute.ftpResponse,
      {
        value1: Commons.EncryptAES(_path),
      }
    ).then((result) => {
      let data = result.data;
      if (data !== 'Error') {
        imgRef.current = `data:image/png;base64,${data}`;
      }
    });
  } catch (e) {
    console.log(e);
  } finally {
  }
};

// 안전보건인력 - 안전보건관리책임자 인쇄 함수
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  custList = [],
  companyInfo = [],
  userInfo = [],
  imgRef = { current: '' }
) => {
  setLoading(true);

  try {
    console.log(rowData1)
    const selectedRow = documentData || rowData1?.[0];

    if (!selectedRow) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }


    const coNm =
      userInfo?.authCd === 'ADMIN'
        ? searchRef?.current?.coList?.find(
          (co) => co.value === searchRef?.current?.coCd
        )?.name || ''
        : companyInfo?.[0]?.coNm || '';

    const ceoNm =
      userInfo?.authCd === 'ADMIN'
        ? searchRef?.current?.coList?.find(
          (co) => co.value === searchRef?.current?.coCd
        )?.ceoName || ''
        : companyInfo?.[0]?.ceoNm || '';

    const headerData = {
      ...selectedRow,
      userNm: selectedRow.managerNm,
      position: selectedRow.position,
      department: selectedRow.depNm,
      appointmentDate: dayjs(selectedRow.manageDate).format(
        'YYYY년 MM월 DD일'
      ),
      custNm: userInfo.custNm,
      coNm: coNm,
      ceoNm: ceoNm,
      // journeyman:
      //   imgRef.current?.replace(/^data:image\/[a-z]+;base64,/, '') || '',
    };
    let FileName = '';
    switch (selectedRow.position) {
      case '안전보건관리책임자':
        FileName = 'SAP_BASIC_02_MST';
        break;
      case '안전보건관리담당자':
        FileName = 'SAP_BASIC_02_MST';
        break;
      case '안전보건총괄책임자':
        FileName = 'SAP_BASIC_03_MST';
        break;
      case '관리감독자':
        FileName = 'SAP_BASIC_04_MST';
        break;
      case '보건관리자':
        FileName = 'SAP_BASIC_06_MST';
        break;
      default:
        FileName = '없음';
    }
    if (FileName === '없음') {
      dispatch(
        showSnackbar({
          message: '선임서에 해당하지 않는 직책입니다.',
          type: 'warning',
        })
      );
      return
    }
    const printData = {
      FileName: FileName,
      HeaderData: JSON.stringify(headerData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error('레포트 서버 미리보기 실패', e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 중 오류가 발생했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};

// 안전보건인력 - 안전보건관리책임자 DTL 조회 함수
export const SearchLogic3 = async (idValue, dispatch, setLoading) => {
  setLoading(true);

  try {
    const result = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSapBasic02R2,
      {
        ManagerId: Commons.EncryptAES(idValue || ''),
      }
    );

    const data = result.data;

    const rows = Array.isArray(data) ? data : data ? [data] : [];
    let selectedManager = null; // 호출부에서 전달 가능하도록 유지
    const originalEvaluationDataRef = { current: new Map() };
    let selectedEvaluationData = null;

    originalEvaluationDataRef.current.clear();

    if (!rows || rows.length === 0) {
      selectedEvaluationData = null;
    } else {
      const rowsWithItems = rows.map((row) => {
        let evaluationItems = row.evaluationItems || [];

        if (!evaluationItems || evaluationItems.length === 0) {
          evaluationItems = [];
        }

        const rowData = {
          ...row,
          evaluationItems: evaluationItems,
        };

        const originalKey = rowData.no || rowData.bpdId;
        if (originalKey) {
          originalEvaluationDataRef.current.set(
            originalKey,
            JSON.parse(JSON.stringify(rowData))
          );
        }

        return rowData;
      });


      if (rowsWithItems.length > 0) {
        const firstItem = rowsWithItems[0];
        let evaluationItems = firstItem.evaluationItems || [];

        if (!evaluationItems.length) {
          evaluationItems = [];
        }
        selectedEvaluationData = [firstItem];

        return {
          success: true,
          data: Commons.InsertNumber(selectedEvaluationData),
          canAdd: selectedEvaluationData[0].custCd !== 'COMMON'
        }
      }
    }

  } catch (e) {
    console.log(e);
    dispatch(
      showSnackbar({
        message: e.message,
        type: 'error',
      })
    );
    return {
      success: false,
      error: e.message,
    };
  } finally {
    setLoading(false);
  }
};

// 안전보건인력 - 안전보건관리책임자 DTL 인쇄 함수
export const PrintLogic2 = async (
  selectedItem,
  custCd,
  userInfo,
  dispatch,
  setLoading
) => {
  if (!selectedItem) {
    dispatch(
      showSnackbar({
        message: '항목을 선택하세요.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);
  let headerData = {};
  let tableData = [];

  try {
    headerData = {
      ...selectedItem,
      position: selectedItem.position,
      name: selectedItem.name,
      opinion: selectedItem.opinion,
      improvements: selectedItem.improvements,
      evaStartDate: dayjs(selectedItem.evaStartDate).format('YYYY.MM.DD'),
      evaEndDate: dayjs(selectedItem.evaEndDate).format('YYYY.MM.DD'),
      today: dayjs().format('YYYY.MM.DD'),
    };
    selectedItem.evaluationItems.forEach((element) => {
      tableData.push({
        evaContent: element.name, // 담당업무
        evaluation: element.grade, // 평가
      });
    });

    const printData = {
      FileName: 'SAP_BASIC_02_DTL',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // blob 반환 (미리보기에서 사용)
    return response.data;
  } catch (e) {
    console.log(e);
    dispatch(
      showSnackbar({
        message: e.message,
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
